import ExcelFormulas from '../utils/ExcelFormulas'

export function annuityCalc({
    typ = 'reko',
    CC = 650000,
    splatnost = 8,
    sazbaPU = 0.0459,
    vedeniUctuUver = 90,
    poplatekSS = 0.01
}) {

    const uzavreniUveru = poplatekSS

    const splatka = Math.round(
        ExcelFormulas.PMT(sazbaPU/12, splatnost  * 12, CC) * -1
        + vedeniUctuUver/3
        + uzavreniUveru * CC / (splatnost * 12)
    )

    return {
        splatkaPUCelkem: splatka,
        splatkaPU: splatka,
        splatkaSU: 0,
        dosporovani: 0,
        sazba: sazbaPU,
        delka: splatnost * 12,
        CC,
    }

}
